import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import Icon from "../../core/Icon";
import Modal from "../../core/Modal";

const AudioPlayerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f2f2f2;
  border-radius: 10px;
  padding: 8px;
  width: 100%;
  height: 100%;
`;

const StyledAudio = styled.audio`
  width: 100%;
  outline: none;
`;

const AudioPlayer = ({ src }) => {
  return (
    <AudioPlayerWrapper>
      <StyledAudio controls autoPlay>
        <source src={src} type="audio/mpeg" />
      </StyledAudio>
    </AudioPlayerWrapper>
  );
};

const ModalBody = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

function AttachmentPreviewModal({ showModal, attachment, onClose }) {
  const attachmentFileType = React.useMemo(() => {
    if (["mpeg", "mp3"].includes(attachment?.fileUrl.split(".").pop())) {
      return "audio";
    }
    if (["jpeg", "png"].includes(attachment?.fileUrl.split(".").pop())) {
      return "image";
    }
    if (attachment?.fileUrl.split(".").pop() === "pdf") {
      return "pdf";
    }
  }, [attachment]);

  if (!showModal) return null;

  return (
    <Modal
      style={{
        padding: 0,
        width: "80%",
        maxWidth: "90%",
        overflowY: "auto",
        minHeight: attachmentFileType === "audio" ? "10%" : "80%",
        maxHeight: "90%",
        position: "relative",
      }}
    >
      <ModalBody>
        {attachmentFileType === "pdf" && (
          <iframe
            src={`${process.env.REACT_APP_FILES_URL}/${attachment?.fileUrl}`}
            style={{ display: "flex", flex: 1, width: "100%", height: "100%" }}
            title={attachment?.title}
          />
        )}
        {attachmentFileType === "image" && (
          <img
            src={`${process.env.REACT_APP_FILES_URL}/${attachment?.fileUrl}`}
            alt="attachment"
            style={{
              height: "98%",
              width: "auto",
              objectFit: "contain",
              border: "1px solid #cecece",
              borderRadius: 4,
            }}
          />
        )}
        {attachmentFileType === "audio" && (
          <AudioPlayer src={`${process.env.REACT_APP_FILES_URL}/${attachment?.fileUrl}`} />
        )}
      </ModalBody>
      <div
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          height: 30,
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <button
          style={{
            background: "#fff",
            padding: "10px",
            borderRadius: "100%",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderColor: "transparent",
          }}
          type="button"
          onClick={onClose}
        >
          <Icon icon="close" cursor="pointer" color="grey" />
        </button>
      </div>
    </Modal>
  );
}

AttachmentPreviewModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  attachment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    fileUrl: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
};

export default AttachmentPreviewModal;
